import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isToday from 'dayjs/plugin/isToday';

import { AstrologicalDetail } from 'hooks/useGetForecast';
import AttributeWithLabel from 'components/common/text/AttributeWithLabel';
import { DateFormats } from 'utils/constants';

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isToday);

type AstrologicalProps = {
  astrological?: AstrologicalDetail;
  className?: string;
  date?: string;
};

function Astrological({ astrological, className, date }: AstrologicalProps) {
  if (astrological) {
    const now = dayjs();
    const sunriseTime = dayjs(`${date}${astrological.sunrise}`, 'YYYY-MM-DDhh:mm A');
    const sunsetTime = dayjs(`${date}${astrological.sunset}`, 'YYYY-MM-DDhh:mm A');
    const lengthOfDay = dayjs.duration(sunsetTime.diff(sunriseTime));
    let remainingDaylight;
    if (now.isToday() && now.isAfter(sunriseTime) && now.isBefore(sunsetTime)) {
      remainingDaylight = dayjs.duration(sunsetTime.diff(now));
    }

    return (
      <div data-testid="astrological" className={className}>
        <div className="mb-2 flex justify-between">
          <AttributeWithLabel
            label="Sunrise"
            value={astrological.sunrise}
            labelClassName="text-sm"
          />
          <AttributeWithLabel
            label="Sunset"
            value={astrological.sunset}
            className="text-right"
            labelClassName="text-sm"
          />
        </div>
        <div className="mb-1 text-sm">
          Length of day {lengthOfDay.format(DateFormats.HOURS_AND_MINUTES)}
        </div>
        {remainingDaylight && (
          <div className="text-sm">
            Remaining daylight {remainingDaylight.format(DateFormats.HOURS_AND_MINUTES)}
          </div>
        )}
      </div>
    );
  }

  return null;
}

export default Astrological;
